<template>
    <v-dialog
        v-model="model"
        persistent
        max-width="500"
    >
        <v-card class="rounded-lg">
            <v-card-text>
                <v-container class="pa-0" v-if="!loading">
                    <v-alert :type="validType">
                        <h3>{{ title }}</h3>
                    </v-alert>
                    <p class="py-5 px-4 ma-0 dialog-message">{{ message }}</p>
                </v-container>
                <v-row
                    class="pa-10"
                    align-content="center"
                    justify="center"
                    v-else
                >
                    <v-col
                        class="subtitle-1 text-center"
                        cols="12"
                    >
                        Processando... Aguarde.
                    </v-col>
                    <v-col cols="8">
                        <v-progress-linear
                            color="primary"
                            indeterminate
                            rounded
                            height="12"
                        ></v-progress-linear>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions v-if="!loading" class="pb-4">
                <v-spacer></v-spacer>
                <v-btn text @click="cancel()" class="rounded-lg">
                    Cancelar
                </v-btn>
                <v-btn :color="validType" @click="confirm()" class="rounded-lg">
                    {{ actionButtonLabel }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import ResponseDialog from "./ResponseDialog.vue";

export default {
    name: "ConfirmActionDialog",
    components: {ResponseDialog},

    props: {
        model: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        },
        actionButtonLabel: {
            type: String,
            default: ''
        }
    },

    methods: {
        cancel() {
            this.$emit('cancel');
            this.$emit('update:model', false);
        },
        confirm () {
            this.loading = true;
            this.$emit('confirm');
        },
    },

    data: () => ({
        loading: false,
        validTypes: ['info', 'error', 'success', 'warning'],
        defaultType: 'info'
    }),

    mounted() {
        if (this.model && !this.message) {
            this.loading = true;
        }
        if (this.message) {
            this.loading = false;
        }
    },

    computed: {
        validType () {
            return this.validTypes.includes(this.type) ? this.type : this.defaultType;
        }
    }
}
</script>

<style lang="scss" scoped>
.v-dialog {
    border-radius: 8px !important;
}

.v-dialog .v-card__text {
    padding: 0 !important;
}

.v-dialog .v-alert {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}

.v-dialog, .v-dialog .v-card__text {
    overflow: hidden !important;
}

.dialog-message {
    font-size: 16px;
    font-weight: 500;
    color: #696A71;
}
</style>
